module.exports = __webpack_public_path__ + "img/Gespraeche.8d10144c.png";